import Slider from "react-slick";

const ProjectSlider = () => {
    const sliderSettings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    return (
        <>
            <Slider {...sliderSettings}>
                <div className="project-block">
                    <div className="image">
                        <img src="assets/images/projects/project1.jpeg" alt="" />
                    </div>
                    <div className="project-meta">
                        <h4 className="h4-style mb-2 text-uppercase"> JSW</h4>
                         <div className="project-location"><i className="fas fa-map-pin"></i>Panvel Maharashtra</div>
                    </div>
                </div>
                <div className="project-block">
                    <div className="image">
                        <img src="assets/images/projects/project9.jpeg" alt="" />
                    </div>
                    <div className="project-meta">
                        <h4 className="h4-style mb-2 text-uppercase">AM/NS</h4>
                         <div className="project-location"><i className="fas fa-map-pin"></i> Surat Hazira</div>
                    </div>
                </div>
            </Slider>
        </>
    )
}

export default ProjectSlider;